import { Injectable } from '@angular/core';
import { EntityServices } from '@ngrx/data';
import { timer } from 'rxjs';

@Injectable({
  providedIn: 'any'
})
export class ResolvedSettingFetcherService {
  constructor(private entityServices: EntityServices) {}

  start() {
    timer(0, 24 * 60 * 60 * 1000)
      .subscribe(() => {
        this.entityServices.getEntityCollectionService('SettingType').load();
        this.entityServices.getEntityCollectionService('SettingNode').load();
      });

    timer(0, 60 * 60 * 1000)
      .subscribe(() => this.entityServices.getEntityCollectionService('ResolvedSetting').load());
  }
}
